import Layout from './Layout'
import DeliveryAddress from './DeliveryAddress'
import DeliveryTimes from './DeliveryTimes'
import CustomerInfo from './CustomerInfo'
import DaData from './DaData'
//import PaymentType from './PaymentType'
import Accepted from './Accepted'

export { Layout, DeliveryAddress, DeliveryTimes, CustomerInfo, DaData, Accepted }



// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/index.js